import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import undefsafe from 'undefsafe'
import intersection from 'lodash/intersection'

import FilterList from './filterList'
import { parseLocation, makeLink } from '../../../../common/utils/urlHelper'
import filterParamsConfig from '../../../../common/constants/filterParamsConfig'

const SelectedFilters = (props) => {
  const { location } = props

  const parsedLocation = parseLocation(location)
  // check there are selected fitlers and the selected filters are in the filter param config
  const hasSelectedFilter = Object.keys(parsedLocation).length > 0 &&
      // has valid filters
      intersection(Object.keys(parsedLocation), Object.keys(filterParamsConfig)).length > 0

  const clearAllLink = parsedLocation.term
    ? makeLink({ category: 'all', term: parsedLocation.term }) : makeLink({ category: 'all' })

  let filteredFilters = Object.keys(parsedLocation)
    .sort((param1, param2) => {
      return undefsafe(filterParamsConfig, `${param1}.order`) > undefsafe(filterParamsConfig, `${param2}.order`)
    })

  // if price_min and price_max are selected at the same time, only show one of them.
  if (parsedLocation.price_min && parsedLocation.price_max) {
    filteredFilters = filteredFilters.filter((filter) => {
      return filter !== 'price_min'
    })
  }

  // if length_min and length_max are selected at the same time, only show one of them.
  if (parsedLocation.length_min && parsedLocation.length_max) {
    filteredFilters = filteredFilters.filter((filter) => {
      return filter !== 'length_min'
    })
  }

  return (
    <div id='selected-filters'>
      {!hasSelectedFilter &&
        <div className='search-facet-refine'>
          Refine your results:
        </div>
      }

      {hasSelectedFilter &&
        <div className='search-facet'>
          <div className='search-facet-actives__remove-all'>
            Your filters:
            <Link to={clearAllLink}>Clear all</Link>
          </div>
          <div className='search-facet-actives__facet-wrapper'>
            {filteredFilters.map((param, key) => {
              return (
                <FilterList
                  parsedLocation={parsedLocation}
                  param={param}
                  key={key}
                />
              )
            })}
          </div>
        </div>
      }
    </div>
  )
}

SelectedFilters.propTypes = {
  location: PropTypes.object.isRequired
}

export default SelectedFilters



// WEBPACK FOOTER //
// ./client/components/filters/selectedFilters/index.js